import React, { Component } from 'react';

import '../style/Home.css';

import loader from '../mal-calender/loader.gif';
import phone1 from '../mal-calender/phone1.jpg';
import appstore from '../mal-calender/appstore_logo.png';
import googleplay from '../mal-calender/google-play-logo-en.png';

import screen1 from '../mal-calender/screens/1.png';
import screen2 from '../mal-calender/screens/2.png';
import screen3 from '../mal-calender/screens/3.png';
import screen4 from '../mal-calender/screens/4.png';
import screen5 from '../mal-calender/screens/5.png';
import screen6 from '../mal-calender/screens/6.png';
import screen7 from '../mal-calender/screens/7.png';
import screen8 from '../mal-calender/screens/8.png';
import screen9 from '../mal-calender/screens/9.png';
import screen10 from '../mal-calender/screens/10.png';

// -------------------------------------------------------------------------------
// reference template
// https://www.free-css.com/free-css-templates/page236/miapp
// -------------------------------------------------------------------------------

class Home extends Component {
    render() {
        return (
            <div>
                <div className='page-borders' >
                    <div className='left' ></div>
                    <div className='right' ></div>
                </div>
                
                <div id='preloader' >
                    <div className='loader' >
                        <img src={loader} alt="" />
                    </div>
                </div>
                
                <div id='main-wrapper' >
                    
                    <section id='intro' className='section intro-section' >
                        <div className='container' >
                            <div className='row intro-cols' >
                                <div className='col-md-6 col-md-push-6' >
                                    <div className='phone' >
                                        <div className='phone-img' >
                                            <img src={phone1} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6 col-md-pull-6' >
                                    <div className='v-align' >
                                        <div className='inner' >
                                            <div className='intro-text' >
                                                <h1>
                                                    Calendar M20
                                                </h1>
                                                <p>
                                                    "The complete informative app for Malayalees"
                                                </p>
                                                <div className='intro-download-btns' >
                                                    <a href='https://apps.apple.com/in/app/malayalam-calendar-m20/id1525128101' className='app-btn' >
                                                        <img src={appstore} alt="" />
                                                    </a>
                                                    <a href='https://play.google.com/store/apps/details?id=com.rester.malayalamcalendar' className='app-btn' >
                                                        <img src={googleplay} alt="" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    
                    <section id='screenshots' className='section screenshots-section bg-lightgray' >
                        <div className='container' >
                            <div className='top-section-header' >
                                <h2>Screenshots</h2>
                                <p>Take a look at the app by its screenshots</p>
                            </div>
                            <ul className='screenshots-slider' >
                                <li>
                                    <div className='inner' >
                                        <img src={screen1} alt="" />
                                        <div className='overlay' >
                                            <a href={screen1} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className='inner' >
                                        <img src={screen2} alt="" />
                                        <div className='overlay' >
                                            <a href={screen2} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className='inner' >
                                        <img src={screen3} alt="" />
                                        <div className='overlay' >
                                            <a href={screen3} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className='inner' >
                                        <img src={screen4} alt="" />
                                        <div className='overlay' >
                                            <a href={screen4} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className='inner' >
                                        <img src={screen5} alt="" />
                                        <div className='overlay' >
                                            <a href={screen5} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className='inner' >
                                        <img src={screen6} alt="" />
                                        <div className='overlay' >
                                            <a href={screen6} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className='inner' >
                                        <img src={screen7} alt="" />
                                        <div className='overlay' >
                                            <a href={screen7} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className='inner' >
                                        <img src={screen8} alt="" />
                                        <div className='overlay' >
                                            <a href={screen8} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className='inner' >
                                        <img src={screen9} alt="" />
                                        <div className='overlay' >
                                            <a href={screen9} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className='inner' >
                                        <img src={screen10} alt="" />
                                        <div className='overlay' >
                                            <a href={screen10} className='view-btn' >
                                                <i className='ion-ios-plus-empty' ></i>
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </section>
                    
                    
                    <section id='download' className='section download-section'>
                        <div className='container' >
                            <div className='row text-center' >
                                <div className='col-md-8 col-md-offset-2' >
                                    <div className='download-text' >
                                        <h2>Download App Now</h2>
                                        <p>
                                            The app made from plenty of request from Keralites
                                            <br/>
                                            Features:- <br/>

                                            First 3D touch-enabled Malayalam calendar app.<br/>
                                            Holidays and festivals list with its full description.<br/>
                                        Reminders with alarm, help you to get alerted<br/>
                                        Global Islamic Prayer Time<br/>
                                            Qibla Finder: Locate the Qibla, wherever you are.<br/>
                                            VachanaPetty: Make Decisions, Enlight Your Life<br/>
                                            Weather details about your region <br/>
                                            Global Sunrise and Sunset<br/>
                                            Malayalam months.<br/>
                                            Nakshatras corresponding to the date.<br/>
                                            Islamic era Hijri.<br/>
                                            Shaka era.<br/>
                                            Daily Raahu kalam, Gulikai, Yamagandam.<br/>
                                            Simple UI that won't be a burden to your phone or even in data consumption. <br/>
                                            Zooming option is available.<br/>
                                            Works in Offline<br/>
                                            Support all iPhones,iPads and Android<br/>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='download-btns text-center' >
                                <a href='https://apps.apple.com/in/app/malayalam-calendar-m20/id1525128101' className='app-btn' >
                                    <img src={appstore} alt="" />
                                </a>
                                <a href='https://play.google.com/store/apps/details?id=com.rester.malayalamcalendar' className='app-btn' >
                                    <img src={googleplay} alt="" />
                                </a>
                            </div>
                        </div>
                    </section>
                    </div>

            </div>
        )
    }
}

export default Home;